<template>
    <x-modal :id="id" :title="modalTitle">
        <x-table :headers="[
            'Nama',
            'Linked Event',
        ]">
            <tr v-for="(eventForm, index) in eventForms" :key="index">
                <td>{{ eventForm.label }}</td>
                <td>{{ eventForm | get('event.label', '-') }}</td>
            </tr>
        </x-table>
        <template #footer>
            <x-close-modal-button />
        </template>
    </x-modal>
</template>

<script>
import XCloseModalButton from '../../components/XCloseModalButton.vue'
import XModal from '../../components/XModal.vue'
import XTable from '../../components/XTable.vue'
export default {
  components: { XModal, XCloseModalButton, XTable },
    computed: {
        eventForms() {
            return _.get(this.rule, 'event_forms', [])
        },
        modalTitle() {
            return _.get(this.rule, 'label', '')
        },
    },
    props: {
        id: {
            type: String,
            required: false,
            default: null,
        },
        rule: {
            type: Object,
            required: false,
            default: null,
        },
    },
}
</script>